import { render } from "./CalculateEphemerides.vue?vue&type=template&id=399eb073"
import script from "./CalculateEphemerides.vue?vue&type=script&lang=js"
export * from "./CalculateEphemerides.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__